// 🔧 event_addons.js
// ✅ Purpose: Shared helpers for checking LGV revenue add-on access per event
// ✅ Features:
// - Reads eventDoc.purchasedAddOns as the source of truth
// - Supports backward compatibility with older event fields during migration
// - Keeps nav/page gating consistent across the app
// - Fully block-commented for clarity and future devs

import { getDefaultPurchasedAddOns } from "../constants/lgv_features";

export const getEventPurchasedAddOns = (eventDoc = {}) => {
  return {
    ...getDefaultPurchasedAddOns(),
    ...(eventDoc?.purchasedAddOns || {}),

    // Social Promotion has one canonical Power Up and one stored legacy alias.
    // Root flags never grant access to Promotion data or provider connections.
    social: eventDoc?.purchasedAddOns?.social === true || eventDoc?.purchasedAddOns?.promotion === true,
    promotion: eventDoc?.purchasedAddOns?.social === true || eventDoc?.purchasedAddOns?.promotion === true,

    // ✅ Backward compatibility
    auction:
      eventDoc?.purchasedAddOns?.auction === true ||
      eventDoc?.purchasedAddOns?.auctions === true ||
      eventDoc?.purchasedAddOns?.silentAuction === true ||
      eventDoc?.purchasedAddOns?.silentAuctions === true ||
      eventDoc?.auctionEnabled === true,

    store:
      eventDoc?.purchasedAddOns?.store === true ||
      eventDoc?.purchasedAddOns?.merchStore === true ||
      eventDoc?.purchasedAddOns?.eventMerchStore === true ||
      eventDoc?.storeEnabled === true,

    tickets:
      eventDoc?.purchasedAddOns?.tickets === true ||
      eventDoc?.purchasedAddOns?.ticketing === true ||
      eventDoc?.purchasedAddOns?.ticketSales === true ||
      eventDoc?.ticketsEnabled === true,

    vendors:
      eventDoc?.purchasedAddOns?.vendors === true ||
      eventDoc?.purchasedAddOns?.vendor === true ||
      eventDoc?.purchasedAddOns?.vendorPayments === true,

    sponsors:
      eventDoc?.purchasedAddOns?.sponsors === true ||
      eventDoc?.purchasedAddOns?.sponsor === true ||
      eventDoc?.purchasedAddOns?.sponsorPayments === true ||
      eventDoc?.sponsorPaymentsEnabled === true,

    vendorPayments:
      eventDoc?.purchasedAddOns?.vendorPayments === true ||
      eventDoc?.vendorsPaymentsEnabled === true ||
      eventDoc?.vendorPaymentsEnabled === true,

    sponsorPayments:
      eventDoc?.purchasedAddOns?.sponsorPayments === true ||
      eventDoc?.sponsorPaymentsEnabled === true,

    passport:
      eventDoc?.purchasedAddOns?.passport === true ||
      eventDoc?.passportEnabled === true,
  };
};

export const hasPurchasedAddOn = (eventDoc = {}, addOnKey = "") => {
  const purchasedAddOns = getEventPurchasedAddOns(eventDoc);

  return purchasedAddOns?.[addOnKey] === true;
};

export const hasAnyPurchasedAddOn = (eventDoc = {}, addOnKeys = []) => {
  return addOnKeys.some((addOnKey) =>
    hasPurchasedAddOn(eventDoc, addOnKey)
  );
};
